export function isWebview(): boolean {
  if (typeof window === 'undefined') return false; // SSR safety

  return new URLSearchParams(window.location.search).get('webview') === 'true';
}
